export default __webpack_public_path__ + "static/media/portfolio-hover-203.a4a22eb9.jpg";